module.exports = __webpack_public_path__ + "fa-brands-400.099a9556e1a63ece24f8.woff";


//////////////////
// WEBPACK FOOTER
// E:/xampp/htdocs/liberado/CocoraSMFront/src/assets/plugins/fontawesome-free/webfonts/fa-brands-400.woff
// module id = ../../../../../src/assets/plugins/fontawesome-free/webfonts/fa-brands-400.woff
// module chunks = styles